import { ChangeEvent, FC, useState } from 'react';
import { ListFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';

import { DropdownListViewModel } from '../../types/dropdownList';
import JabraLegend from '../Shared/JabraLegend';
import TspLabel from './TspLabel';
import TspSelect from './TspSelect';

const TspDropdownList: FC<ListFieldProps<DropdownListViewModel>> = (props) => {
  const { field, isValid } = props;
  const { id, name } = field.valueField;
  const { dictionaryLabel, items, labelCssClass, labelOption, showEmptyItem, showLegend, title } =
    field.model;
  const [value, setValue] = useState(props.value[0]);
  const FieldValidationErrors = props.fieldValidationErrorsComponent;

  const onChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const newValue = event?.target?.value;
    setValue(newValue);
    props.onChange(name, newValue, isValid, []);
  };

  return (
    <>
      <TspLabel {...props} />
      <TspSelect
        id={id}
        name={name}
        value={value}
        jssMetadata={props}
        required={field.model.required}
        onChange={onChange}
      >
        {showEmptyItem && <option value="">{labelOption || dictionaryLabel}</option>}
        {items.map(({ itemId, value, text }) => (
          <option key={itemId} value={value}>
            {text}
          </option>
        ))}
      </TspSelect>
      {showLegend && !!title && (
        <JabraLegend className={labelCssClass} dangerouslySetInnerHTML={{ __html: title }} />
      )}
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};

export default TspDropdownList;
